import { useIntl } from 'react-intl';

import { Text } from '@calm-web/design-system';

import messages from '@/components/emotion-detector/messages';
import { BaseCard } from '@/components/emotion-detector/shared/BaseCard';
import { useEmotionDetection } from '@/hooks/emotion-detector';
import { TopEmotion } from '@/utils/emotion-detector';

import ConfirmPrompt from './components/ConfirmPrompt';
import EmotionGridComponent from './components/EmotionGridComponent';
import { TitleContainer } from './styles';
import { handleEmotionAction } from './utils';

interface EmotionSelectionProps {
	emotionDetection: ReturnType<typeof useEmotionDetection>;
	isVisible: boolean;
	onEmotionConfirmed: (emotion: TopEmotion) => void;
}

export default function EmotionSelection({
	emotionDetection,
	isVisible,
	onEmotionConfirmed,
}: EmotionSelectionProps) {
	const { formatMessage } = useIntl();
	const { pendingEmotion, needsConfirm, selectedEmotion, confirmDetected, chooseEmotion } = emotionDetection;

	const handleEmotionSelect = async (emotion: TopEmotion) => {
		await handleEmotionAction(() => chooseEmotion(emotion), onEmotionConfirmed);
	};

	const handleConfirm = async () => {
		await handleEmotionAction(confirmDetected, onEmotionConfirmed);
	};

	if (!isVisible) return null;

	const title = needsConfirm
		? formatMessage(messages.cameraConfirmEmotion)
		: formatMessage(messages.cameraSelectEmotion);

	return (
		<BaseCard data-card="selection">
			<TitleContainer>
				<Text el="h2">{title}</Text>
			</TitleContainer>

			{needsConfirm && pendingEmotion && <ConfirmPrompt emotion={pendingEmotion} onConfirm={handleConfirm} />}

			<EmotionGridComponent selectedEmotion={selectedEmotion} onEmotionSelect={handleEmotionSelect} />
		</BaseCard>
	);
}
